import { lazy } from 'react';

export const EventControlsPage = lazy(() => import('./controller.js'));
